import { Facebook, MapPin, Clock, Phone, Mail } from "lucide-react";

export default function Contact() {
  return (
    <section id="contact" className="py-20 sm:py-28 px-4 sm:px-8 bg-[#F5EFDE]/60">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C59B27]">Contact Us</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#0C2340] mt-4">
            We'd love to hear from you
          </h2>
          <p className="mt-4 text-base text-zinc-600">
            The fastest way to reach us — from anywhere in the world — is through
            our official Facebook page. You can also call, email, or visit the Park.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          <a
            href="https://www.facebook.com/DavaoMemorialPark"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="facebook-page-link"
            className="group bg-[#0C2340] rounded-2xl p-8 text-center hover:bg-[#091A30] transition-all duration-300 hover:-translate-y-1 shadow-[0_4px_20px_rgba(12,35,64,0.15)]"
          >
            <span className="inline-flex w-14 h-14 rounded-full bg-[#C59B27]/15 items-center justify-center">
              <Facebook className="w-7 h-7 text-[#C59B27]" />
            </span>
            <h3 className="text-white font-semibold mt-5">Facebook Page</h3>
            <p className="text-white/60 text-sm mt-2">facebook.com/DavaoMemorialPark</p>
            <span className="inline-block mt-4 text-sm font-semibold text-[#C59B27] group-hover:underline">
              Message Us Now →
            </span>
          </a>

          <div data-testid="contact-location-card" className="bg-white rounded-2xl border border-[#0C2340]/10 p-8 text-center shadow-[0_4px_20px_rgba(12,35,64,0.06)]">
            <span className="inline-flex w-14 h-14 rounded-full bg-[#2E5A44]/10 items-center justify-center">
              <MapPin className="w-7 h-7 text-[#2E5A44]" />
            </span>
            <h3 className="text-[#0C2340] font-semibold mt-5">Visit the Park</h3>
            <p className="text-zinc-600 text-sm mt-2 leading-relaxed">
              Gen. Douglas MacArthur Highway, Matina, Davao City, Davao del Sur, Philippines
            </p>
            <p data-testid="contact-hours" className="inline-flex items-center gap-1.5 text-zinc-500 text-xs mt-3">
              <Clock className="w-3.5 h-3.5" />
              Monday to Sunday, 9:00 AM – 6:00 PM
            </p>
          </div>

          <div data-testid="contact-phone-card" className="bg-white rounded-2xl border border-[#0C2340]/10 p-8 text-center shadow-[0_4px_20px_rgba(12,35,64,0.06)]">
            <span className="inline-flex w-14 h-14 rounded-full bg-[#C59B27]/10 items-center justify-center">
              <Phone className="w-7 h-7 text-[#C59B27]" />
            </span>
            <h3 className="text-[#0C2340] font-semibold mt-5">Call Us</h3>
            <a
              href="tel:+639303549877"
              data-testid="contact-phone-link"
              className="block text-zinc-600 text-sm mt-2 hover:text-[#C59B27] transition-colors"
            >
              +63 930 354 9877
            </a>
            <a
              href="tel:+63822960332"
              data-testid="contact-landline-link"
              className="block text-zinc-600 text-sm mt-1 hover:text-[#C59B27] transition-colors"
            >
              Landline: (082) 296-0332
            </a>
          </div>

          <div data-testid="contact-email-card" className="bg-white rounded-2xl border border-[#0C2340]/10 p-8 text-center shadow-[0_4px_20px_rgba(12,35,64,0.06)]">
            <span className="inline-flex w-14 h-14 rounded-full bg-[#0C2340]/10 items-center justify-center">
              <Mail className="w-7 h-7 text-[#0C2340]" />
            </span>
            <h3 className="text-[#0C2340] font-semibold mt-5">Email Us</h3>
            <a
              href="mailto:davaomemorialpark@gmail.com"
              data-testid="contact-email-link"
              className="block text-zinc-600 text-sm mt-2 break-all hover:text-[#C59B27] transition-colors"
            >
              davaomemorialpark@gmail.com
            </a>
            <p className="text-zinc-500 text-xs mt-3">
              Ideal for OFWs — write to us anytime, from any time zone.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
